import { Row, Col } from "reactstrap";
import SalesforceFieldsTable from "./salesforceFieldsTable";

const QuoteOverviewSalesforceTable = ({salesforceFields}) => {
    if (!salesforceFields) return;

    const removeUnwantedFields = (fields) => {
        return fields.filter(field => {
            const valuesToExclude = ["null", "0", "", "false", "None"];
            if (field.label.includes(" ID") || valuesToExclude.includes(field.value) || field.value.startsWith('{"' /* This is a link to another object */)) {  
                return false;
            }
            return true;
        })
    }

    const removeEmptyGroups = (groups) => {
        const newGroups = structuredClone(groups);
        newGroups.forEach(group => {
            group.items = removeUnwantedFields(group.items);
        });

        return newGroups.filter(group => group.items && group.items.length > 0);
    }
    
    const opportunityFieldsPushed = removeEmptyGroups(salesforceFields.pushedToOpportunity || []);
    const iQuoteFieldsPushed = removeEmptyGroups(salesforceFields.pushedToiQuote || []);
    const opportunityFields = removeEmptyGroups(salesforceFields.inOpportunity || []);
    const iQuoteFields = removeEmptyGroups(salesforceFields.inIquote || []);

    return (
        <>
            {opportunityFields.length === 0 && iQuoteFields.length === 0 && (
                <Row className="mb-3">
                    <Col >
                        Please wait whilst Salesforce data is loaded...
                    </Col>
                </Row>
            )}
            <Row className="mb-4">
                <Col >
                    <SalesforceFieldsTable header="Opportunity Fields Sent To Salesforce" salesforceFields={opportunityFieldsPushed} />
                </Col>
                <Col >
                    <SalesforceFieldsTable header="iQuote Fields Sent To Salesforce" salesforceFields={iQuoteFieldsPushed} />
                </Col>
            </Row>
            <Row className="mb-4">
                <Col >
                    <SalesforceFieldsTable header="Other Opportunity Fields In Salesforce" salesforceFields={opportunityFields} />
                </Col>
                <Col >
                    <SalesforceFieldsTable header="Other iQuote Fields In Salesforce" salesforceFields={iQuoteFields} />
                </Col>
            </Row>

        </>
    );
}

export default QuoteOverviewSalesforceTable;